import { observer } from "mobx-react-lite";
import { FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { appRoutes } from "@/app/router";
import { googleIdentityModule } from "@/modules/google-identity";
import { AuthCardLogInWithGoogleButton } from "@/components/auth/google/auth-card-log-in-with-google-button";
import { AuthCardBase } from "@/components/auth/auth-card-base";
import { usePublicAppStore } from "@/store";
import { AuthCardLogInWithEmailPasswordButton } from "@/components/auth/email-password/auth-card-log-in-with-email-password-button";

export interface AuthCardLogInProps {}

export const AuthCardLogIn: FC<AuthCardLogInProps> = observer(() => {
  const navigate = useNavigate();
  const { publicStore } = usePublicAppStore();

  const shouldShowEmailPasswordButton = publicStore.debug.debugModeEnabled;

  const logInWithGoogle = useCallback(async () => await googleIdentityModule.triggerLogIn(), []);

  const logInWithEmailPassword = useCallback(() => {
    navigate(appRoutes.logInEmailPassword({}).path);
  }, [navigate]);

  return (
    <AuthCardBase>
      <AuthCardLogInWithGoogleButton onClick={logInWithGoogle} />
      {shouldShowEmailPasswordButton && (
        <AuthCardLogInWithEmailPasswordButton onClick={logInWithEmailPassword} />
      )}
    </AuthCardBase>
  );
});
